// Configuration dynamique pour l'API backend
// Cette approche détecte automatiquement l'environnement

/**
 * Obtient l'URL du backend de manière intelligente
 * 
 * Priorité :
 * 1. Variable d'environnement REACT_APP_BACKEND_URL (si définie au build)
 * 2. Détection automatique basée sur window.location (production)
 * 3. Fallback vers localhost (développement)
 */
export const getBackendUrl = () => {
  // PRIORITÉ 1: Détection automatique en production (RUNTIME)
  // Force doozum.com à utiliser son propre domaine
  if (typeof window !== 'undefined') {
    const host = window.location.host;
    const protocol = window.location.protocol;
    
    // Si sur doozum.com (production), toujours utiliser le même domaine
    if (host === 'doozum.com' || host === 'www.doozum.com') {
      console.log('🚀 Production detected: Using', `${protocol}//${host}`);
      return `${protocol}//${host}`;
    }
    
    // Si HTTPS (autre production), utiliser le même domaine
    if (protocol === 'https:') {
      console.log('🚀 HTTPS detected: Using', `${protocol}//${host}`);
      return `${protocol}//${host}`;
    }
  }
  
  // PRIORITÉ 2: Variable d'environnement (COMPILE TIME - uniquement pour dev)
  if (process.env.REACT_APP_BACKEND_URL && 
      process.env.REACT_APP_BACKEND_URL !== '' &&
      !process.env.REACT_APP_BACKEND_URL.includes('taskflow')) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // PRIORITÉ 3: Fallback localhost (développement local)
  return 'http://localhost:8001';
};

// Export de l'URL configurée
export const API_BASE_URL = getBackendUrl();

// Log pour debug (seulement en développement)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Backend URL configured:', API_BASE_URL);
}
